"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tabs = _interopRequireDefault(require("../tabs"));

var _icon = _interopRequireDefault(require("../icon"));

var _iconButton = _interopRequireDefault(require("../iconButton"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _select = _interopRequireDefault(require("../select"));

var _button = _interopRequireDefault(require("../button"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isAppDrawerOpen: false,
      showNotifications: false,
      showSettings: false,
      showProfile: false
    });

    return _this;
  }

  _createClass(Header, [{
    key: "toggleDrawer",
    value: function toggleDrawer(isAppDrawerOpen) {
      this.setState({
        isAppDrawerOpen: isAppDrawerOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isAppDrawerOpen = _this$state.isAppDrawerOpen,
          showNotifications = _this$state.showNotifications,
          showSettings = _this$state.showSettings,
          showProfile = _this$state.showProfile;
      var _this$props = this.props,
          filter = _this$props.filter,
          active = _this$props.active,
          _this$props$profile = _this$props.profile,
          name = _this$props$profile.name,
          image = _this$props$profile.image,
          role = _this$props$profile.role,
          office = _this$props$profile.office,
          domainProtocol = _this$props.domainProtocol,
          domainSuffix = _this$props.domainSuffix,
          _this$props$links = _this$props.links,
          companySettings = _this$props$links.companySettings,
          officeSettings = _this$props$links.officeSettings,
          mySettings = _this$props$links.mySettings,
          logout = _this$props$links.logout,
          roles = _this$props$links.roles,
          offices = _this$props$links.offices;
      var apps = [// { link: `${domainProtocol}flow.${domainSuffix}`, icon: "flow", title: "Flow" },
      // {
      //   link: `${domainProtocol}buyer-drive.${domainSuffix}`,
      //   icon: "buyer-drive",
      //   title: "Buyer Zone",
      // },
      {
        link: "".concat(domainProtocol, "maps.").concat(domainSuffix),
        icon: "maps",
        title: "Maps"
      }, // {
      //   link: `${domainProtocol}open-homes.${domainSuffix}`,
      //   icon: "open-homes",
      //   title: "Open Homes",
      // },
      {
        link: "".concat(domainProtocol, "email.").concat(domainSuffix),
        icon: "email",
        title: "Email"
      }, {
        link: "".concat(domainProtocol, "contacts.").concat(domainSuffix),
        icon: "contacts",
        title: "Contacts"
      } // {
      //   link: `${domainProtocol}marketplace.${domainSuffix}`,
      //   icon: "marketplace",
      //   title: "Marketplace",
      // },
      // { link: `${domainProtocol}shop.${domainSuffix}`, icon: "shop", title: "Shop" },
      // {
      //   link: `${domainProtocol}marketing.${domainSuffix}`,
      //   icon: "marketing",
      //   title: "Marketing",
      // },
      // { link: `${domainProtocol}reports.${domainSuffix}`, icon: "reports", title: "Reports" },
      // {
      //   link: `${domainProtocol}my-property.${domainSuffix}`,
      //   icon: "my-property",
      //   title: "My Property",
      // },
      // { link: `${domainProtocol}website.${domainSuffix}`, icon: "website", title: "Website" },
      // {
      //   link: `${domainProtocol}target-audience.${domainSuffix}`,
      //   icon: "target-audience",
      //   title: "Targeted Audience",
      // },
      // {
      //   link: `${domainProtocol}compliance.${domainSuffix}`,
      //   icon: "compliance",
      //   title: "Compliance",
      // },
      // { link: `${domainProtocol}reviews.${domainSuffix}`, icon: "reviews", title: "Review" },
      // {
      //   link: `${domainProtocol}accounts.${domainSuffix}`,
      //   icon: "accounts",
      //   title: "Accounts",
      // },
      // {
      //   link: `${domainProtocol}file-library.${domainSuffix}`,
      //   icon: "file-library",
      //   title: "File Library",
      // },
      // {
      //   link: `${domainProtocol}coaching.${domainSuffix}`,
      //   icon: "coaching",
      //   title: "Coaching",
      // },
      // {
      //   link: `${domainProtocol}digital-forms.${domainSuffix}`,
      //   icon: "digital-forms",
      //   title: "Digital Forms",
      // },
      // {
      //   link: `${domainProtocol}trust-account.${domainSuffix}`,
      //   icon: "trust-account",
      //   title: "Trust Account",
      // },
      // {
      //   link: `${domainProtocol}reminders.${domainSuffix}`,
      //   icon: "reminders",
      //   title: "Reminders",
      // },
      // {
      //   link: `${domainProtocol}automation.${domainSuffix}`,
      //   icon: "automation",
      //   title: "Automation",
      // },
      // {
      //   link: `${domainProtocol}client-portal.${domainSuffix}`,
      //   icon: "client-portal",
      //   title: "Client Portal",
      // },
      // {
      //   link: `${domainProtocol}apps-and-api.${domainSuffix}`,
      //   icon: "apps-and-api",
      //   title: "APPS & API",
      // },
      // { link: `${domainProtocol}offers.${domainSuffix}`, icon: "offers", title: "Offers" },
      // {
      //   link: `${domainProtocol}appraisals.${domainSuffix}`,
      //   icon: "appraisals",
      //   title: "Appraisals",
      // },
      // { link: `${domainProtocol}smarts.${domainSuffix}`, icon: "smarts", title: "Smarts" },
      // { link: `${domainProtocol}support.${domainSuffix}`, icon: "support", title: "Support" },
      // {
      //   link: `${domainProtocol}settings.${domainSuffix}`,
      //   icon: "settings",
      //   title: "Setting",
      // },
      ];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "right-menu"
      }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
        className: "app-switcher"
      }, /*#__PURE__*/_react.default.createElement(_iconButton.default, {
        icon: "app",
        onClick: function onClick() {
          return _this2.toggleDrawer(true);
        },
        className: isAppDrawerOpen ? "active" : ""
      }), isAppDrawerOpen && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "app-switcher-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "app-switcher-container-header"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "app"
      }), /*#__PURE__*/_react.default.createElement("span", null, "Select App"), /*#__PURE__*/_react.default.createElement(_iconButton.default, {
        icon: "edit"
      })), /*#__PURE__*/_react.default.createElement("ul", null, apps.map(function (_ref) {
        var link = _ref.link,
            icon = _ref.icon,
            title = _ref.title;
        return /*#__PURE__*/_react.default.createElement("li", {
          key: title,
          className: (0, _classnames.default)({
            active: active === icon
          })
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: link
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: require("../assets/logos/".concat(icon, ".svg")),
          alt: "logo"
        }), /*#__PURE__*/_react.default.createElement("span", null, title)), /*#__PURE__*/_react.default.createElement(_iconButton.default, {
          icon: "menu"
        }));
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "app-switcher-overlay",
        onClick: function onClick() {
          return _this2.toggleDrawer(false);
        }
      })))), /*#__PURE__*/_react.default.createElement("img", {
        src: require("../assets/logos/".concat(active, ".svg")),
        alt: "logo",
        className: "logo"
      })), /*#__PURE__*/_react.default.createElement("div", null, filter), /*#__PURE__*/_react.default.createElement("div", {
        className: "left-menu"
      }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null), /*#__PURE__*/_react.default.createElement("li", {
        className: "settings-icon"
      }, /*#__PURE__*/_react.default.createElement(_iconButton.default, {
        icon: "settings",
        onClick: function onClick() {
          return _this2.setState({
            showSettings: !showSettings
          });
        }
      }), showSettings && /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu settings-menu"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu-top box-bg ",
        onClick: function onClick() {
          return _this2.setState({
            showSettings: !showSettings
          });
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, "Settings"), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu-right"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "settings"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu-list box-bg "
      }, companySettings && /*#__PURE__*/_react.default.createElement("a", {
        href: companySettings,
        className: "header-menu-list-item"
      }, "Company Settings"), officeSettings && /*#__PURE__*/_react.default.createElement("a", {
        href: officeSettings,
        className: "header-menu-list-item"
      }, "Office Settings"), /*#__PURE__*/_react.default.createElement("a", {
        href: mySettings,
        className: "header-menu-list-item"
      }, "My Settings"))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "profile"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "name",
        onClick: function onClick() {
          return _this2.setState({
            showProfile: !showProfile
          });
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "user"
      }, name), /*#__PURE__*/_react.default.createElement("div", {
        className: "role"
      }, role && office && "".concat(office === null || office === void 0 ? void 0 : office.name, " (").concat(role === null || role === void 0 ? void 0 : role.title, ")"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "menu-down",
        onClick: function onClick() {
          return _this2.setState({
            showProfile: !showProfile
          });
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "chevron-down"
      })), /*#__PURE__*/_react.default.createElement(_avatar.default, {
        src: image && image === "" ? image : require("./placeholder-img.jpg")
      }), showProfile && /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu user-menu"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu-top box-bg ",
        onClick: function onClick() {
          return _this2.setState({
            showProfile: !showProfile
          });
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Profile"), " ", /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "settings"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu-right"
      }, /*#__PURE__*/_react.default.createElement(_avatar.default, {
        src: image && image === "" ? image : require("./placeholder-img.jpg")
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-menu-list box-bg "
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: mySettings,
        className: "header-menu-list-item"
      }, "My Profile"), roles.map(function (_ref2, key) {
        var title = _ref2.title,
            link = _ref2.link,
            office = _ref2.office;
        return /*#__PURE__*/_react.default.createElement("a", {
          href: link,
          key: key,
          className: "header-menu-list-item"
        }, title, /*#__PURE__*/_react.default.createElement("span", null, office));
      }), /*#__PURE__*/_react.default.createElement("a", {
        href: logout,
        className: "header-menu-list-item"
      }, "Logout"))))));
    }
  }]);

  return Header;
}(_react.Component);

Header.propTypes = {
  filter: _propTypes.default.any,
  active: _propTypes.default.string.isRequired,
  profile: _propTypes.default.object,
  links: _propTypes.default.object
};
var _default = Header;
exports.default = _default;